import React from 'react';
import { noop, map } from 'lodash';
import classnames from 'classnames';

// local dependencies
import { withNetworkState } from 'ui/hoc/withNetworkState';
import { TableSearchWidget } from 'ui/containers/TableSearchWidget';
import { callWidgetItemDetailSummaryPreloader as CSrOrderListNotesWorkFlowItemPreloader } from 'ui/views/widgets/callWidgetItemDetailSummary';
import { button as Button } from 'modules/button';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { cSrOrderListNotesWorkFlowLog as CSrOrderListNotesWorkFlowLog } from 'ui/views/widgets/cSROrderListNotesWorkFlowLog';
 *
 * // render
 * <CSrOrderListNotesWorkFlowLog propName='propValue'/>
 */
export const cSrOrderListNotesWorkFlowLogSuccess = ( props ) => {
    return (
            <div className='ui-c-sr-order-list-notes-work-flow-log'>
                <TableSearchWidget
                    templateType='inline'
                    layoutConfig={ { dimensions: { padding: 0 } } }
                    tableResponse={ { ...props } }
                    disablePagination={ true }
                />

                <div className='ui-c-sr-order-list-notes-work-flow-log__actions'>
                    { map( props.actions, action => {
                        return (
                            <Button
                                key={ action.name }
                                { ...action }
                                outline={ 'cancel' !== action.name ? true: false }
                                size='large'
                                className='ui-c-sr-order-list-notes-work-flow-log__actions__action'
                                onClick={'cancel' !== action.name ? () => props.onAddClick( true ) : () => props.onCancelClick() }
                            />
                        );
                    } ) }
                </div>
            </div>
    );
};

// set display name
cSrOrderListNotesWorkFlowLogSuccess.displayName = 'cSrOrderListNotesWorkFlowLogSuccess';


// set default props
cSrOrderListNotesWorkFlowLogSuccess.defaultProps = {
    componentData: {},
    layoutConfig: {},
    onActionClick: noop,
 };
 
 // prop types
 cSrOrderListNotesWorkFlowLogSuccess.propTypes = {};
 
 /*******************************/
 
 // preloader view
 export const cSrOrderListNotesWorkFlowLogPreloader = ( props ) => {
 
     // widget class name
     const widgetClassName = classnames( 'ui-call-list-widget-preloader', props.className );
 
     return (
         <div className={ widgetClassName }>
             <CSrOrderListNotesWorkFlowItemPreloader columnlength = { 6 } />
         </div>
     );
 };
 
 // set display name
 cSrOrderListNotesWorkFlowLogPreloader.displayName = 'cSrOrderListNotesWorkFlowLogPreloader';
 
 // set default props
 cSrOrderListNotesWorkFlowLogPreloader.defaultProps = {};
 
 // prop types
 cSrOrderListNotesWorkFlowLogPreloader.propTypes = {};
 
 /*******************************/
 
 /**
  * @type {object}
  * @desc A React presentation/dumb view component.
  * @example
  * import { cSrOrderListNotesWorkFlowLog as cSrOrderListNotesWorkFlowLog } from 'ui/views/widgets/cSrOrderListNotesWorkFlowLog';
  *
  * // render
  * <cSrOrderListNotesWorkFlowLog propName='propValue'/>
  */
 export const cSrOrderListNotesWorkFlowLog = withNetworkState( cSrOrderListNotesWorkFlowLogPreloader, cSrOrderListNotesWorkFlowLogSuccess );

